import { Collections } from "@mui/icons-material";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import FeaturedVideoIcon from "@mui/icons-material/FeaturedVideo";
import MarkUnreadChatAltOutlinedIcon from "@mui/icons-material/MarkUnreadChatAltOutlined";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";


export const menuItems = [
  {
    title: "مدیریت دسته بندی",
    subroutes: [
      {
        name: "دسته بندی ",
        path: "/category",
      },
      /*      {
        name: "دسته بندی  فیلد",
        path: "/categoryFeild",
      }, */
      {
        name: "  فیلد ها",
        path: "/field",
      },
      /*     {
        name: "مقادیر فیلد",
        path: "/fieldValue",
      }, */
      /*       {
        name: "فیلد های دسته بندی  های اصلی",
        path: "/mainCategoryFeild",
      }, */
    ],
    icon: <CategoryOutlinedIcon fontSize="inherit" />,
  },
  {
    title: "  غرفه و کاربران",
    subroutes: [
      {
        name: "غرفه ها",
        path: "/booth",
      },
      {
        name: "کابران",
        path: "/users",
      },
      /*    {
        name: "مورد علاقه ها",
        path: "/wishList",
      },
      {
        name: "  اخرین بازدید ها",
        path: "/lastVisit",
      }, */
    ],
    icon: <PeopleAltIcon fontSize="inherit" />,
  },
  {
    title: "آگهی ها",
    subroutes: [
      {
        name: "آگهی ",
        path: "/advertisment",
      },
      /*      {
        name:  "تبلیغات مقادیر ",
        path: "/advertismentData",
      },
      {
        name: "  تصاویر تبلیغات",
        path: "/advertismentGallery",
      }, */
    ],
    icon: <FeaturedVideoIcon fontSize="inherit" />,
  },
  {
    title: "تبلیغات",
    subroutes: [{ name: "پلن‌ها و جایگاه‌ها", path: "/promotions" }],
    icon: <CampaignOutlinedIcon fontSize="inherit" />,
  },
  {
    title: "تیکت",
    subroutes: [
      /*       {
        name: "گفت گو ها ",
        path: "/conversation",
      }, */
      {
        name: " چت ",
        path: "/chat",
      },
    ],
    icon: <MarkUnreadChatAltOutlinedIcon fontSize="inherit" />,
  },
  {
    title: "گزارشات",
    subroutes: [
      {
        name: "گزارش گردش مالی",
        path: "/transaction",
      },
    ],
    icon: <AssessmentOutlinedIcon fontSize="inherit" />,
  },
  {
    title: "گالری تصاویر",
    subroutes: false,
    path: "/gallery",
    icon: <Collections fontSize="inherit" />,
  },
  {
    title: "تنظیمات",
    subroutes: [
      {
        name: "اسلایدر",
        path: "/slider",
      },
      {
        name: "کشور",
        path: "/country",
      },
      {
        name: " مشخصات شرکت",
        path: "/companyInfo",
      },
      {
        name: "تنظیمات پنل ادمین",
        path: "/configs",
      },
      {
        name: "تنظیمات درگاه پرداخت",
        path: "/payment-gateway",
      },
    ],
    icon: <SettingsOutlinedIcon fontSize="inherit" />,
  },
];
